export const environment = {
  production: true,
  sentry: {
    enabled: true,
    dsn: 'https://ddd2e6c9d1aa00b50117fba9fa0b7f30@sentry.gozem.co/57',
    environment: 'production',
  },
  apiUrl: 'https://merchant-app.gozem.co',
  s3BaseUrl: '',
  appName: 'Gozem Web App',
  version: '0.0.0',
  merchantType: '2',
  deviceType: 'web',
  googleMapsApiKey: 'AIzaSyD7e-s2Z8pjcW2cmZ9QqWxUwdEm-W6uSlc',
  webToken:
    'BPuVaoqvje2QFDArxViqiOM8qmaT80yWlcK_Z1SkTh8ZZl6eKHMYwgdou26pYxr-tl0t8gupMPv1ejs8RTpaGC8',
  // Static API key for the public partner lead form (POST /api/lead/lead_register).
  leadApiKey: '4a95014be9cfd7f1e5e7c46529fbcb38',
  firebaseConfig: {
    apiKey: 'AIzaSyDiIn-7qldLgl4bbe_uO8pmUOABWNsQh04',
    authDomain: 'gozem-merchant-app.firebaseapp.com',
    projectId: 'gozem-merchant-app',
    storageBucket: 'gozem-merchant-app.firebasestorage.app',
    messagingSenderId: '392536206905',
    appId: '1:392536206905:web:8236fa4c82fe60284467e8',
    measurementId: 'G-X71WLK1PVJ',
  },
};
